import * as yup from "yup";

export const AccountantSetupValidationSchema = yup.object().shape({
	accTitle: yup
		.string()
		.required("Accountant Title is required")
		.min(1, "Minimum length 1 characters")
		.max(50, "Maximum length 50 characters"),
	firstName: yup
		.string()
		.required("First Name is required")
		.min(1, "Minimum length 1 characters")
		.max(30, "Maximum length 30 characters"),
	lastName: yup
		.string()
		.required("Last Name is required")
		.min(1, "Minimum length 1 characters")
		.max(30, "Maximum length 30 characters"),
	initial: yup
		.string()
		// .required("Last Name is required")
		// .min(1, "Minimum length 1 characters")
		.max(3, "Maximum length 3 characters"),
	addressLine1: yup
		.string()
		.required("Address is required")
		.min(1, "Minimum length 1 characters")
		.max(100, "Maximum length 100 characters"),
	city: yup
		.string()
		.required("City is required")
		.min(1, "Minimum length 1 characters")
		.max(30, "Maximum length 30 characters"),
	province: yup.string().required("Province is required"),
	country: yup.string().required("Country is required"),
	// postalCode: yup
	//   .string()
	//   .required("PostCode is required")
	//   .max(10, "Post Code has at most 10 characters"),
	phone: yup.string().required("Phone is required"),
	// .min(14, "Minimum length 10 characters")
	// fax: yup
	// .string()
	// // .required("Phone is required")
	// .max(14, "Minimum length 10 characters"),
	// email: yup
	// 	.string()
	// 	.email("Must be a valid email address")
	// 	.required("Email is required")
	// 	.max(100, "Maximum length 100 characters"),
	email: yup
		.string()
		.trim()
		.required("Email is required")
		.email("Must be a valid email address")
		//   .matches(/\.[A-Za-z]{2,}$/, "Must be a valid email address")
		.matches(/\.[A-Za-z]{2,}$/, {
			message: "Must be a valid email address",
			excludeEmptyString: true,
		})
		.max(100, "Maximum length 100 characters"),
	// startDate: yup
	// .string()
	// .required("Start Date is required"),

	// postalCode: yup.string().when("country", {
	//   is: (val: any) => val === "CAN",
	//   then: yup
	//     .string()
	//     .required("Postal Code is required")
	//     .min(6, "Atleast 6 character required")
	//     .max(6, "Maximum 6 characters required"),
	// }),
	// postalCode: yup.string().when("country", (country:any, schema:any) => {

	//   if (country === "CAN") {
	//     return schema
	//       .required("Postal Code is required")
	//       .length(6, "Postal Code must be exactly 6 characters"); // `length` instead of `min` and `max`
	//   }
	//   return schema; // Return schema unchanged for other countries
	// }),
	// zipCode: yup.string().when("country", (country:any, schema:any) => {
	//   if (country === "USA") {
	//     return schema
	//       .required("Zip Code is required")
	//       .length(6, "Zip Code must be exactly 6 characters"); // `length` instead of `min` and `max`
	//   }
	//   return schema; // Return schema unchanged for other countries
	// }),
});
